import { Big } from "big.js";
import { GetItemsProps, useApiService } from "medere-ui-framework";

export function useWithholdingService() {
  const { getMethod, postMethod } = useApiService();
  const baseEndpoint = "/api/public/withholdingrestcontroller";

  async function calculateWithholdings(company: number, taxtype: number, totalamount: Big, percentage: Big, withholdingconcept: number) {
    try {
      return await postMethod<any>({
        basePath: baseEndpoint,
        endpoint: "/calculateWithholdings",
        body: null,
        params: {
          company: company,
          taxType: taxtype,
          totalAmount: totalamount,
          percentage: percentage,
          withholdingconcept: withholdingconcept
        }
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  function getEarningWithholdingConcepts({ filterValue, offSet, pageSize }: GetItemsProps) {
    return getMethod({
      basePath: baseEndpoint,
      endpoint: "/getEarningWithholdingConcepts",
      params: {
        offSet: offSet,
        pageSize,
        inputText: filterValue ?? ""
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getEarningWithholdingConceptById(withholdingconcept: number) {
    return getMethod({
      basePath: baseEndpoint,
      endpoint: "/getEarningWithholdingConceptById",
      params: { withholdingconcept }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  return {
    calculateWithholdings,
    getEarningWithholdingConcepts,
    getEarningWithholdingConceptById,
  };
}
